<template>
    <input id="textFont">
</template>

<script>
    export default {
        mounted() {
            var self = this
            $('#textFont').fontselect().change(function() {
            var textFont = $(this).val().replace(/\+/g, ' ');
                textFont = textFont.split(':');
                  self.$emit('get-font-text', textFont[0]);
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/JQueryPluggins/FontText.vue